import React, { useState, useEffect } from 'react';
import LegalPageLayout from '../../components/LegalPageLayout/LegalPageLayout';
import { getLegalContent } from '../../services/legalService';

const TermsPage: React.FC = () => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    getLegalContent().then((content) => {
      setMarkdown(content.terms_markdown ?? '');
    });
  }, []);

  return (
    <LegalPageLayout
      title="Terms and Conditions"
      markdown={markdown}
    />
  );
};

export default TermsPage;
